
import { ElForm } from 'element-ui/types/form'
import pick from 'lodash/pick'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import { AppModule } from '@/store/modules/app'

const checkStatus = {
    pass: { value: 1, name: '已通过' },
    not: { value: 2, name: '待审核' },
    reject: { value: 3, name: '未通过' }
}

/**
 * @prop form           表单内容
 * @prop onlyShow       只展示，数据不可编辑
*/
@Component({
    name: 'company-detail-form'
})
export default class CompanyDetailForm extends Vue {
    @Prop({ default: () => {} }) private form: any
    @Prop({ default: false }) private onlyShow!: boolean

    private companyForm = {
        company_type_id: '',
        name: '',
        short_name: '',
        stock_code: '',
        logo: '',
        phone: '',
        email: '',
        official_url: '',
        address: '',
        intro: '',
        industry_ids: '',
        cm_name: '',
        sec_name: '',
        check: checkStatus.not.value,
        products: [{                
            key: +new Date(),
            name: '',               
            url: ''                 
        }]
    }
    private classOptions = []
    private checkStatus = Object.values(checkStatus)
    private companyFormRules = {
        name: [
            { required: true, message: '请输入机构名称' }
        ],
        short_name: [
            { required: true, message: '请输入机构简称' }
        ]
    }
    get industryList() {
        return AppModule.industry
    }
    get isShowDeleteButton() {
        return this.companyForm.products.length > 1
    }
    @Watch('form', { immediate: true, deep: true })
    private watchForm(val: any) {
        if (!Object.keys(val).length) return
        const newForm: any = { ...this.companyForm }
        for (const key in val) {
            if (val[key] !== undefined && val[key] !== null) {
                newForm[key] = val[key]
            }
        }
        newForm.name = val.name || (val.company && val.company.name) || ''
        newForm.short_name = val.short_name || val.shortName || val.shortname || ''
        newForm.official_url = val.official_url || val.officialUrl || ''
        newForm.stock_code = val.stock_code || val.stockCode || ''
        newForm.created_at = val.created_at || val.createdAt || ''
        newForm.updated_at = val.updated_at || val.updatedAt || ''
        newForm.user_id = val.user_id || val.userId || ''
        newForm.check = val.check !== undefined ? val.check : (val.status !== undefined ? val.status : checkStatus.not.value)
        newForm.industry_ids = val.industry_ids || val.industry || []
        newForm.products = val.products && Array.isArray(val.products) ? val.products.map((n: any, i: number) => ({ ...n, key: `p${i}` })) : []
        this.companyForm = newForm
    }

    private created() {
        this.getClassList()
    }

    // 企业分类
    private async getClassList() {
        const result = await EnterpriseService.getClassList()
        if (result.status === 200) {
            this.classOptions = result.data
        }
    }

    private onDeleteProduct(product: any) {
        const products = this.companyForm.products as any[]
        const idx = products.indexOf(product)
        products.splice(idx, 1)
    }

    private addProduct() {
        (this.companyForm.products as any).push({
            key: +new Date(),
            name: '',
            url: ''
        })
    }

    private validate(fn: Function) {
        (this.$refs.companyformRef as ElForm).validate((isValid: boolean) => {
            if (!isValid) return
            const industry = (() => {
                const ids = this.companyForm['industry_ids']
                if (Array.isArray(ids)) {
                    return ids.map(n => n.pop())
                }
                return []
            })()
            let form = { 
                ...this.companyForm, 
                industry_ids: industry,
                products: this.companyForm['products'].map(p => pick(p, ['name', 'url']))
            }
            fn && fn(form)
        })
    }
}
